import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { api, ApiError } from '../../api/client'
import { detectPlatformAdapter } from '../../platform'
import { Button } from '../../components/ui/Button'
import { LoadingDots } from '../../components/ui/LoadingDots'

export function CompatRedeemRoute() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const tokenFromUrl = params.get('token')
  const tokenFromTg = detectPlatformAdapter().getStartParam()
  const token = tokenFromUrl ?? tokenFromTg ?? ''

  const redeem = useMutation({
    mutationFn: () => api.redeemCompatInvite(token),
    onSuccess: (data) => navigate(`/compat/${data.id}`, { replace: true }),
  })

  useEffect(() => {
    if (token && token.startsWith('compat_') && !redeem.isPending && !redeem.data) {
      redeem.mutate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  if (!token || !token.startsWith('compat_')) {
    return (
      <div className="flex flex-col items-center gap-4 py-10 text-center text-sage-700">
        <p>{t('compat.redeem_title')}</p>
        <p className="text-sm text-sage-500">No token provided</p>
        <Button onClick={() => navigate('/compat')}>{t('actions.back')}</Button>
      </div>
    )
  }

  if (redeem.isError && redeem.error instanceof ApiError) {
    return (
      <div className="flex flex-col items-center gap-4 py-10 text-center text-sage-700">
        <h1 className="font-serif text-2xl text-sage-800">{t('compat.redeem_title')}</h1>
        <p className="text-sm text-copper">{redeem.error.message}</p>
        <Button onClick={() => navigate('/compat')}>{t('actions.back')}</Button>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center gap-4 py-10 text-center text-sage-700">
      <h1 className="font-serif text-2xl text-sage-800">{t('compat.redeem_title')}</h1>
      <p className="text-sage-600">{t('compat.redeem_subtitle')}</p>
      <LoadingDots compact />
    </div>
  )
}
